import { ConciergeKnowledgeSchema } from "@redotech/redo-model/concierge-knowledge";
import * as z from "zod/v4";

export const getSuggestedKnowledge = {
  name: "getSuggestedKnowledge" as const,
  input: z.object({ filters: z.object({ searchText: z.string().optional() }) }),
  output: z.array(ConciergeKnowledgeSchema),
};

export type GetSuggestedKnowledgeOutput = z.infer<
  typeof getSuggestedKnowledge.output
>;
